import type { ApiClient } from '../../core/api-client.js';
import { ApiError } from '../../core/api-client.js';
import type { Resultado } from '../../core/resultado.js';
import type { PaginaFaturamento, FiltroFaturamento } from '@pgcustom/shared-types';

/**
 * Adapter do módulo Faturamento no frontend — único ponto que conhece o
 * formato de `GET /api/v1/faturamento` (`faturamento.routes.ts`). Mesmo
 * padrão de `FinanceiroApi`: devolve `Resultado<T>` para alimentar
 * estados de UI direto.
 */
export class FaturamentoApi {
  constructor(private readonly api: ApiClient) {}

  async listar(filtro: FiltroFaturamento = {}): Promise<Resultado<PaginaFaturamento>> {
    try {
      const params: Record<string, string | number> = {};
      if (filtro.busca) params.busca = filtro.busca;
      if (filtro.pagoDesde) params.pagoDesde = filtro.pagoDesde;
      if (filtro.statusOperacional) params.statusOperacional = filtro.statusOperacional;
      if (filtro.statusFiscal) params.statusFiscal = filtro.statusFiscal;
      if (filtro.origem) params.origem = filtro.origem;
      if (filtro.limit) params.limit = filtro.limit;

      // Sempre `ok` — mesmo sem linhas os KPIs (todos zerados) devem aparecer;
      // a ausência de linhas é tratada como estado vazio da TABELA, não da tela.
      const resposta = await this.api.get<PaginaFaturamento>('/faturamento', params);
      return { status: 'ok', dado: resposta };
    } catch (erro) {
      if (erro instanceof ApiError && erro.status === 403) return { status: 'sem-permissao' };
      return {
        status: 'erro',
        mensagem: erro instanceof ApiError ? erro.message : 'falha ao carregar o faturamento',
      };
    }
  }
}
